export default {"src":"/_next/static/media/icone-potential.a417b388.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};